import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import awsconfig from './hooks/useWebSocketAWSConfig';
// import { Amplify } from 'aws-amplify';
// Amplify.configure(awsconfig);


import { Amplify } from 'aws-amplify';

Amplify.configure(awsconfig);



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <App />
 //</React.StrictMode>
);